import React, { Component, useState } from 'react'
import PulseLoader from "react-spinners/PulseLoader";
import { Modal } from 'react-bootstrap'
export default function LoadingModal(props) {

    return (
        <Modal show={props.display}
            backdrop="static"
            centered
            size={`sm`} className={`new-case-loading-modal`}>
            <Modal.Body style={{ "margin": "auto" }}>
                <PulseLoader
                    size={25}
                    color={"#bbb"}
                    loading={true}
                />
            </Modal.Body>
        </Modal>)
}